import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

type SwitchProps = {
    checked: boolean
    onCheckedChange: (value: boolean) => void
    id?: string
    disabled?: boolean
    className?: string
    'aria-label'?: string
    'aria-labelledby'?: string
    'aria-describedby'?: string
}

export const Switch: FC<SwitchProps> = ({ checked, onCheckedChange, id, disabled, className, ...aria }): ReactNode => {
    return (
        <button
            type='button'
            role='switch'
            id={id}
            aria-checked={checked}
            disabled={disabled}
            onClick={() => onCheckedChange(!checked)}
            className={cn(
                'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border-2 border-transparent transition-colors outline-none',
                'focus-visible:ring-3 focus-visible:ring-ring/40 disabled:cursor-not-allowed disabled:opacity-50',
                checked ? 'bg-primary' : 'bg-input',
                className
            )}
            {...aria}
        >
            <span
                className={cn(
                    'pointer-events-none block size-5 rounded-full bg-white shadow-sm transition-transform duration-200',
                    checked ? 'translate-x-5' : 'translate-x-0'
                )}
                aria-hidden='true'
            />
        </button>
    )
}
